import React from 'react';
import { Deck } from './components/Deck';
export function App() {
  return <div className="w-full h-full min-h-screen bg-[var(--bg)]" data-id="element-0">
      <Deck data-id="element-1" />
    </div>;
}